import { BaseFieldModel, IBaseFieldModel } from '../base/blueprint-field-base.model';

export interface IFieldDateTimeModel extends IBaseFieldModel {
  isRequired: boolean;
  isReadOnly: boolean;
  value: Date | null;
}
export class FieldDateTimeModel extends BaseFieldModel implements IFieldDateTimeModel {
  constructor(
    public isRequired: boolean,
    public isReadOnly: boolean,
    public value: Date | null,
  ) {
    super(isRequired, isReadOnly);
  }
}
